import { render } from "./PaymentMedia.vue?vue&type=template&id=2493b53a"
import script from "./PaymentMedia.vue?vue&type=script&lang=js"
export * from "./PaymentMedia.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__